import { activeFilterKeys, type FilesFilters } from "../types/files-filters.types.ts"

// Of what containerFilterParams sends, the folder and album endpoints answer only these.
const CONTAINER_FILTER_KEYS: Array<keyof FilesFilters> = ["created_by_origin", "customers"]

/** The loaded folders and albums a Files search or filter result lists beside its files. */
export const containersInFilteredResult = <Folder, Album>(
  loaded: { folders: Folder[]; albums: Album[] },
  filters: FilesFilters,
  isSearching: boolean
): { folders: Folder[]; albums: Album[] } => {
  const active = activeFilterKeys(filters)
  const narrowedByContainerFilter = active.some((key) => CONTAINER_FILTER_KEYS.includes(key))
  const containersCannotAnswer = active.some(
    (key) =>
      !CONTAINER_FILTER_KEYS.includes(key) &&
      // Uploaded by is the files' half of an origin filter whose containers' half is Created by or Customer.
      !(key === "uploaded_by_origin" && narrowedByContainerFilter)
  )
  if (containersCannotAnswer) {
    return { folders: [], albums: [] }
  }
  return {
    folders: isSearching || narrowedByContainerFilter ? loaded.folders : [],
    albums: isSearching ? loaded.albums : []
  }
}
